<template>
    <div>
        <item-write-link v-for="writeLayout in writeLayouts" :key="`itemComp${writeLayout}`"
                         :writeLayout="writeLayout" :itemData="itemData"></item-write-link>
    </div>
</template>

<script>
import ItemWriteLink from "@/components/item/ItemWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import itemValidator from "@/mixins/validators/itemValidator";
import itemUtil from "@/components/item/itemUtil";
import DeleteClass from "@/mixins/deleteClass";

export default {
    name: "ItemWriteComponent",
    mixins: [alertMixins, itemUtil, itemValidator],
    components: {ItemWriteLink},
    inject: ['changeLoading'],
    provide() {
        return {
            itemWriteSetData: this.setData,
            itemDelete: this.runDeleteConfirm,
        }
    },
    props: {
        itemType: {},
        itemKey: {default: 0},
    },
    data() {
        return {
            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            fileType: '',
            getFunc: '',
            detailApiParamsSet: {},
            itemData: {},
            date: '',

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            /*필터 classname*/
            DeleteClass: null,
        }
    },
    created() {
        this.initFilterConfig();
        if (this.itemKey != 0) {
            this.getItem();
        } else {
            this.initTemplateConfig();
        }
    },
    mounted() {
        EventBus.$on('writeItem', this.writeItem);

    },
    beforeDestroy() {
        EventBus.$off('writeItem');

    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        initTemplateConfig() {
            let configItem = this.returnItemConfig(this.itemType);
            this.writeLayouts = configItem.writeLayouts;
        },
        initFilterConfig() {
            let configItem = this.returnItemConfig(this.itemType);
            this.writeFunc = configItem.writeFunc;
            this.writeApiParamSet = configItem.writeApiParamSet;
            this.parsingData = configItem.parsingData;
            this.getFunc = configItem.getFunc;
            this.detailApiParamsSet = configItem.detailApiParamsSet;
            this.directUrl = configItem.directUrl;
            this.directType = configItem.directType;
            this.keyName = configItem.keyName;
            this.getDetailParamsKey = configItem.getDetailParamsKey;
            this.writeSuccessType = configItem.writeSuccessType;
            this.writeFailTypes = configItem.writeFailTypes;

            this.deleteFunc = configItem.deleteFunc;
            this.deleteApiParamsSet = configItem.deleteApiParamsSet;
            this.deleteSuccessType = configItem.deleteSuccessType;
            this.deleteFailTypes = configItem.deleteFailTypes;
        },
        getItem() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            !util.isEmpty(this.getDetailParamsKey) ? params[this.getDetailParamsKey] = this.itemKey : params.id = this.itemKey;
            this.$api.$item[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 && res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.itemData = res.List[0];
                this.initTemplateConfig();
            })
        },
        writeItem() {
            let dataArr = Object.keys(this.parsingData);
            this.$validate(dataArr).then(success => {
                if (!success) {
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, dataArr);
                    });
                    this.errorAlert('필수정보를 모두 입력해주세요.');
                    return;
                }
                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                dataArr = Object.keys(this.parsingData);
                dataArr.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                })

                if (this.itemKey != 0) {
                    params[this.keyName] = this.itemKey;
                } else {
                    params.i_price_org = this.price;
                }

                try {
                    this.$api.$item[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnItemType(res.Info.type);
                        if (type != true) {
                            this.changeLoading(false);
                            this.errorAlert(type);
                            return false;
                        }
                        this.afterFunc(res.List);
                    });

                } catch (e) {
                    this.changeLoading(false);
                    console.log(e);
                }
            })
        },

        returnItemType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
            }
        },
        afterFunc(key) {
            this.changeLoading(false);
            let detailKey = key;
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getItem();
                        return false;
                    }
                    let url = this.directUrl;
                    if (this.directType === 'detail') {
                        url = url + detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },

        runDeleteConfirm() {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: () => {
                    this.runDelete();
                }
            })
        },
        runDelete() {
            if (this.isRunning) return false;
            this.changeLoading(true)
            let params = {
                'i_idx': [this.itemKey],
                'type': 'sub',
            };

            try {
                this.$api.$item[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
                    let status = res.Info.status;
                    if (!status) {
                        this.errorAlert('삭제에 실패했습니다.');
                        this.changeLoading(false);
                        return;
                    }
                    this.deleteAfterFunc();
                    return;
                })
            } catch (e) {
                this.changeLoading(false);
                return;
            }
        },
        deleteAfterFunc() {
            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    this.changeLoading(false);
                    this.$router.push('/item/item');
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
